import React from "react";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrintingPlatform from "./PrintingPlatform";
import AdminPage from "./AdminPage";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";

ChannelService.loadScript();
ChannelService.boot({
  pluginKey: "15042e62-28ff-4996-85d6-badb1a077e70", // fill your plugin key
});
function Footer() {
  return (
    <footer class="bg-gray-900 py-16 text-white">
      <div class="container mx-auto px-6">
        <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
          <div>
            <div class="mb-6 flex items-center space-x-2">
              <span class="text-xl font-bold">주식회사 레이어블</span>
            </div>
            <ul class="space-y-2">
              <li class="text-gray-400">모든 창작자들의 꿈과 이야기를 세상에 펼치도록</li>

              <li class="text-gray-400">문의: 1877-3218</li>
              <li class="text-gray-400">이메일: contact@layable.kr</li>
            </ul>
          </div>
          <div>
            <ul class="space-y-2">
              <h4 class="mb-4 hidden text-lg font-bold lg:block">‭ ‭ ‭ ‭</h4>
              <li class="text-gray-400">대표이사: 장범준</li>
              <li class="text-gray-400">
                경기도 수원시 영통구 광교로 145 A동 1323호
                <br />
                (차세대융합기술연구원)
              </li>
              <li class="text-gray-400">사업자등록번호: 772-87-03404</li>
              <li class="text-gray-400">통신판매업신고: 제 2024-수원영통-1830호</li>
            </ul>
          </div>
          <div>
            <h4 class="mb-4 text-lg font-bold">바로가기</h4>
            <ul class="space-y-2 text-gray-400">
              <li>
                <a href="//layable.kr" class="text-gray-400 hover:text-white">
                  홈페이지
                </a>
              </li>
              <li>
                <button type="button" onClick={() => ChannelService.openChat()} className="text-gray-400 cursor-pointer hover:text-white">
                  1:1 문의
                </button>
              </li>
              <li>
                <a href="//shop.layable.kr" class="text-gray-400 hover:text-white">
                  Shop
                </a>
                &nbsp;/&nbsp;
                <a href="//3dmake.layable.kr" class="text-gray-400 hover:text-white">
                  3D 제작대행
                </a>
              </li>
              <li>
                <a href="//layable.kr/#/tos" class="text-gray-400 hover:text-white">
                  이용약관
                </a>
                &nbsp;/&nbsp;
                <a href="//layable.kr/#/privacy" class="text-gray-400 hover:text-white">
                  개인정보처리방침
                </a>
              </li>
              {/* <li>
                  <a href="#" class="text-gray-400 hover:text-white">
                    환불규정
                  </a>
                </li> */}
            </ul>
          </div>
        </div>
        <div class="mt-12 border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>© 2025 Layable. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

function App() {
  useEffect(() => {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (window.innerWidth <= 500) {
      viewportMeta?.setAttribute("content", "width=device-width, initial-scale=0.9");
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <PrintingPlatform />
              <Footer />
            </>
          }
        />
        <Route
          path="/admin"
          element={
            <>
              <AdminPage />
              <Footer />
            </>
          }
        />
        <Route
          path="*"
          element={
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
              <div className="text-center">
                <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
                <p className="text-xl text-gray-600 mb-8">페이지를 찾을 수 없습니다</p>
                <a href="/" className="text-teal-500 hover:text-teal-600 font-medium">
                  홈으로 돌아가기
                </a>
              </div>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
